import { Section, SectionField } from "types/Models/Filing";
import { filterServerDocuments } from "utils/filterServerDocuments";

export const mapSectionFieldWithFormValues = (
  sectionField: SectionField,
  formValues: Record<string, any>
): SectionField => {
  const fieldValue =
    formValues?.[sectionField.field_key] || sectionField?.value;

  if (sectionField?.type === "file_upload") {
    const documents =
      formValues?.[sectionField.field_key] ?? sectionField?.documents;

    return {
      ...sectionField,
      value: fieldValue,
      documents: filterServerDocuments(documents),
    };
  }

  return { ...sectionField, value: fieldValue };
};

export const mapSectionWithFormValues = <T extends Partial<Section>>(
  section: T,
  formValues: Record<string, any>
): T => ({
  ...section,
  section_fields: section.section_fields?.map((sectionField) =>
    mapSectionFieldWithFormValues(sectionField, formValues)
  ),
  repeatable_fields: section.repeatable_fields?.map((repeatableField) => ({
    ...repeatableField,
    fields: repeatableField.fields?.map((field) =>
      mapSectionFieldWithFormValues(field, formValues)
    ),
  })),
});

export const findAutofillKey = (
  keys: string[],
  fieldKey: string,
  ignoreList: Record<string, string> = {
    street_address: "street_address_line_2",
  }
): string | undefined =>
  keys.find((key) => {
    const ignoreWhen = ignoreList[key];
    if (ignoreWhen && fieldKey?.includes(ignoreWhen)) {
      return false;
    }
    return key !== "" && fieldKey?.includes(key);
  });
